export default __webpack_public_path__ + "static/media/cassandra.0752a10c.svg";